import { Manifesto } from "features/Manifesto";

export default Manifesto;
